"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessorLoader = void 0;
const viewer_data_engine_shared_types_1 = require("@shapediver/viewer.data-engine.shared-types");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class AccessorLoader {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(_content, _bufferViewLoader) {
        this._content = _content;
        this._bufferViewLoader = _bufferViewLoader;
        // #region Properties (2)
        this._logger = viewer_shared_services_1.Logger.instance;
        this._loaded = {};
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    getAccessor(accessorId) {
        if (!this._content.accessors)
            throw new Error("AccessorLoader.getAccessor: Accessors not available.");
        if (!this._content.accessors[accessorId])
            throw new Error("AccessorLoader.getAccessor: Accessor not available.");
        if (this._loaded[accessorId] === undefined)
            throw new Error("AccessorLoader.getAccessor: Accessor not loaded.");
        return this._loaded[accessorId];
    }
    load() {
        if (!this._content.accessors)
            return;
        for (let i = 0; i < this._content.accessors.length; i++) {
            const accessorId = i;
            if (!this._content.accessors[accessorId])
                throw new Error("AccessorLoader.load: BufferView not available.");
            const accessor = this._content.accessors[accessorId];
            if (accessor.bufferView === undefined) {
                // Ignore empty accessors, which may be used to declare runtime
                // information about attributes coming from another source (e.g. Draco
                // compression extension).
                this._loaded[accessorId] = null;
                continue;
            }
            const arrayBuffer = this._bufferViewLoader.getBufferView(accessor.bufferView);
            const itemSize = viewer_data_engine_shared_types_1.ACCESSORTYPE_V2[accessor.type];
            if (accessor.componentType === 5124)
                this._logger.warn("GLTFLoader.loadAccessor: The componentType for this accessor is 5124, which is not allowed. Trying to load it anyway.");
            const ArrayType = viewer_data_engine_shared_types_1.ACCESSORCOMPONENTTYPE_V2[accessor.componentType];
            const elementBytes = ArrayType.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessor.byteOffset || 0;
            const byteStride = accessor.bufferView !== undefined
                ? this._content.bufferViews
                    ? this._content.bufferViews[accessor.bufferView]
                        .byteStride
                    : undefined
                : undefined;
            const normalized = accessor.normalized === true;
            const target = this._content.bufferViews
                ? this._content.bufferViews[accessor.bufferView].target
                : undefined;
            let array;
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                array = new ArrayType(arrayBuffer, ibSlice * byteStride, (accessor.count * byteStride) / elementBytes);
            }
            else {
                if (arrayBuffer === null) {
                    array = new ArrayType(accessor.count * itemSize);
                }
                else {
                    array = new ArrayType(arrayBuffer, byteOffset, accessor.count * itemSize);
                }
            }
            if (array.length === 0) {
                // Ignore empty accessors, they are not allowed in glTF
                this._logger.warn("GLTFLoader.loadAccessor: Accessor with zero length found.");
                this._loaded[accessorId] = null;
                continue;
            }
            if (accessor.sparse !== undefined) {
                const itemSizeIndices = viewer_data_engine_shared_types_1.ACCESSORTYPE_V2.SCALAR;
                const IndicesArrayType = viewer_data_engine_shared_types_1.ACCESSORCOMPONENTTYPE_V2[(accessor.sparse.indices.componentType)];
                const byteOffsetIndices = accessor.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessor.sparse.values.byteOffset || 0;
                if (!accessor.sparse.indices.bufferView ||
                    !accessor.sparse.values.bufferView)
                    throw new Error("Sparse Mesh not properly defined.");
                const sparseIndices = new IndicesArrayType(this._bufferViewLoader.getBufferView(accessor.sparse.indices.bufferView), byteOffsetIndices, accessor.sparse.count * itemSizeIndices);
                const sparseValues = new ArrayType(this._bufferViewLoader.getBufferView(accessor.sparse.values.bufferView), byteOffsetValues, accessor.sparse.count * itemSize);
                this._loaded[accessorId] = new viewer_shared_types_1.AttributeData(array, itemSize, itemBytes, byteOffset, elementBytes, normalized, accessor.count, accessor.min, accessor.max, byteStride, target, true, sparseIndices, sparseValues);
                continue;
            }
            this._loaded[accessorId] = new viewer_shared_types_1.AttributeData(array, itemSize, itemBytes, byteOffset, elementBytes, normalized, accessor.count, accessor.min, accessor.max, byteStride, target);
        }
    }
}
exports.AccessorLoader = AccessorLoader;
//# sourceMappingURL=AccessorLoader.js.map